import {Module} from 'vuex';
import RootState from '@/store/rootState';
import {Breakpoint} from '@/types/Breakpoint';

export interface BreakpointState {
    list: Breakpoint[];
}

// noinspection JSUnusedGlobalSymbols
const breakpoints: Module<BreakpointState, RootState> = {
    namespaced: true,

    state: {
        list: [],
    },

    mutations: {
        CLEAR(state: BreakpointState) : void {
            state.list = [];
        },

        REPLACE(state: BreakpointState, bkps: Breakpoint[]) : void {
            state.list = bkps;
        },

        SWAP(state: BreakpointState, bkp: Breakpoint) : number {
            if (state.list.find((i) => i.filename === bkp.filename && i.line === bkp.line) === undefined) {
                state.list = [...state.list, bkp];
                return 1;
            } else {
                state.list = state.list.filter((i) => i.filename !== bkp.filename || i.line !== bkp.line);
                return -1;
            }
        },
    },
};

export default breakpoints;
